import { Component, ElementRef, OnInit, inject } from '@angular/core';
import { runtimeEventManager } from '@wm/core';
import { BaseComponent } from '@wms/components';
import { WidgetPropertiesProvider } from '@wms/design-container';
import { get } from 'lodash-es';
import {getCanvasElement} from "@wms/core";
import {PageWorkspaceComponent, PageWsService} from "@wms/workspace";
import {NgClass, NgIf} from "@angular/common";

@Component({
  standalone: true,
  selector: 'wms-widget-context-menu',
  templateUrl: './wms-widget-context-menu.component.html',
  imports: [
    NgClass,
    NgIf
  ],
  styleUrls: ['./wms-widget-context-menu.component.less']
})
export class WmsWidgetContextMenuComponent extends BaseComponent implements OnInit {
  hasListenerOnDoc: boolean = false;
  $el: any;
  widgetProperties: any;
  $widget: any;
  widgetId: any;
  $ref: any;
  copiedMarkup: any;
  ignoreClose: boolean = false;
  private selectedWidgetsCount: number = 0;
  pageWS: any;
  pageWsService: any;
  hideWidgetName:boolean= true;


  constructor(private elementRef: ElementRef) {
    super();
    this.widgetProperties = inject(WidgetPropertiesProvider);
    this.pageWS =inject(PageWorkspaceComponent);
    this.pageWsService = inject(PageWsService);
    this.registerDestroyListener.add(runtimeEventManager.on('set-copied-markup').subscribe((data: string) => {
      this.copiedMarkup = data;
    }));

    this.registerDestroyListener.add(this.eventManager.widgetSelectionCountObservable().subscribe((count) => {
      this.selectedWidgetsCount = count;
    }));
  }

  ngOnInit(): void {
    setTimeout(() => {
      let $canvasEl: any;
      const shadowHost = document.querySelector('wms-canvas-sandbox-wrapper');
      this.$el = $(this.elementRef.nativeElement).find('.canvas-context-menu');
      this.$ref = {
        'openParital': this.$el.find('> [data-id="open-partial"]'),
        'cut': this.$el.find('> [data-id=cut]'),
        'copy': this.$el.find('> [data-id=copy]'),
        'paste': this.$el.find('> [data-id=paste]'),
        'delete': this.$el.find('> [data-id=delete]'),
        'duplicate': this.$el.find('> [data-id=duplicate]'),
        'autolayout': this.$el.find('> [data-id=autolayout]'),
        'redo': this.$el.find('> [data-id=redo]'),
        'undo': this.$el.find('> [data-id=undo]'),
        'save': this.$el.find('> [data-id=save]'),
        'collapse': this.$el.find('> [data-id=collapse]'),
        'showHide': this.$el.find('> [data-id=showHide]'),
      };

      /* If project is of type prism then it'll be wrapped inside the shadow dom and any selector inside it
      needs to be accessed via the same */
      $canvasEl = $(getCanvasElement());

      $($canvasEl).on('contextmenu', (e) => {
        // disabling the keyboard events based on rbac permissions
        if (!get(this.preferences, 'project.pages.edit')) {
          e.stopPropagation();
          e.preventDefault();
          return;
        }
        if (!this.hasListenerOnDoc) {
          this.hasListenerOnDoc = true;
          $(document.body)
            .one('mousedown', (e) => {
              this.hasListenerOnDoc = false;
              let $target = $(e.target);
              if ($target.is(':not(.domcontent *)') && $target.is(':not(.canvas-context-menu *)')) {
                this.$el.addClass('ng-hide');
              }
            });
        }

        this.$el.removeClass('ng-hide');

        this.$widget = $(e.target).closest('[widgetid]');
        this.widgetId = this.$widget.attr('widgetid');

        let widgetType = this.$widget.attr('widgettype'),
          widgetConfig = widgetType ? this.widgetProperties.getConfig(widgetType) : {},
          numberOfOptions = 11;

        // name
        // this.$ref.widgetName.text(this.$widget.attr('name'));
        // this.$ref.widgetName.attr('title', this.$widget.attr('name'));

        if (this.$widget.is('[partialcontainer]') && this.$widget.attr('content')) {
          this.$ref.openParital.removeClass('ng-hide');
          numberOfOptions += 1;
        } else {
          this.$ref.openParital.addClass('ng-hide');
        }

        // if the widget is header, topnav, leftnav, rightnav, footer hide the cut, copy, paste, delete actions
        if (this.$widget.is('[widgettype="wm-header"], [widgettype="wm-top-nav"], [widgettype="wm-left-panel"], [widgettype="wm-right-panel"], [widgettype="wm-footer"]')) {
          this.$ref.cut.addClass('ng-hide');
          this.$ref.copy.addClass('ng-hide');
          this.$ref.paste.addClass('ng-hide');
          this.$ref.delete.addClass('ng-hide');
          this.$ref.duplicate.addClass('ng-hide');
          this.$ref.autolayout.addClass('ng-hide');
          this.hideWidgetName = false;
          numberOfOptions -= 5;
        } else {
          this.$ref.cut.removeClass('ng-hide');
          this.$ref.copy.removeClass('ng-hide');
          this.$ref.paste.removeClass('ng-hide');
          this.$ref.delete.removeClass('ng-hide');
          this.$ref.duplicate.removeClass('ng-hide');
          this.hideWidgetName = true;
        }

        // copy, cut
        if (widgetConfig.canBeCopied) {
          this.$ref.cut.removeClass('disabled');
          this.$ref.copy.removeClass('disabled');
          this.$ref.duplicate.removeClass('disabled');
        } else {
          this.$ref.cut.addClass('disabled');
          this.$ref.copy.addClass('disabled');
          this.$ref.duplicate.addClass('disabled');
        }

        if(this.pageWsService.isUndoDisabled()){
          this.$ref.undo.addClass('disabled');
        }else {
          this.$ref.undo.removeClass('disabled');
        }

        if(this.pageWsService.isRedoDisabled()){
          this.$ref.redo.addClass('disabled');
        }else {
          this.$ref.redo.removeClass('disabled');
        }
        if(!this.pageWsService.hiddenElementsExist){
          this.$ref.showHide.addClass('disabled');
        }else{
          this.$ref.showHide.removeClass('disabled');
        }
        // delete
        if (widgetConfig.isDeletable && widgetType !== 'wm-pagedialog') {
          this.$ref.delete.removeClass('disabled');
        } else {
          this.$ref.delete.addClass('disabled');
        }

        if (this.copiedMarkup) {
          this.$ref.paste.removeClass('disabled');
        } else {
          this.$ref.paste.addClass('disabled');
        }

        if (this.$widget.is('[widgettype="wm-view"]')) {
          this.$ref.paste.addClass('disabled');
        }

        if(this.selectedWidgetsCount > 1){
          // this.$ref.widgetName.addClass('ng-hide');
          this.$ref.autolayout.removeClass('ng-hide');
          numberOfOptions += 1;
          const otherKeys = ['openParital','cut','copy','paste','delete','duplicate'];

          otherKeys.forEach((k) => {
            if (this.$ref[k]) {
              this.$ref[k].addClass('disabled');
            }
          });
        } else {
          // this.$ref.widgetName.removeClass('ng-hide');
          this.$ref.autolayout.addClass('ng-hide');
        }

        this.$el.css(this.getDisplayPos(e, numberOfOptions));
      }).on('click', () => {
        if (!this.ignoreClose) {
          this.$el.addClass('ng-hide');
        }
        this.ignoreClose = false;
      }).on('mousewheel', () => {
        this.$el.addClass('ng-hide');
      });

      this.$el.on('click', 'li[data-id]', (e: any) => {
        const liEl: any = $(e.target).closest('li');
        let action = liEl[0].getAttribute('data-id');
        if (liEl.hasClass('disabled')) {
          this.$el.addClass('ng-hide');
          return;
        }

        e.stopPropagation();

        if (action) {
          if (action === 'open-partial') {
            runtimeEventManager.emit('loadPage', this.$widget.attr('content'));
          } else if (action === 'autolayout') {
            runtimeEventManager.emit('add-autolayout');
          } else {
            runtimeEventManager.emit('perform-widget-action', action.toString().toUpperCase());
          }
          if(action === 'save'){
            this.pageWsService.startAutoSave(true);
          }
          if(action === 'collapse'){
            runtimeEventManager.emit('collapse');
          }
          if(action === 'undo'){
            this.pageWS.undo()
          }
          if(action === 'redo'){
            this.pageWS.redo()
          }
          if(action === 'showHide'){
            this.pageWsService.toggleHiddenElements()
          }
          this.$el.addClass('ng-hide');
        }
      }).on('contextmenu', (e: any) => {
        e.preventDefault();
      });
    });
  }

  getDisplayPos(e: any, numberOfOptions: any) {
    e.preventDefault();

    numberOfOptions += 1;

    let winH: any = $(window).innerHeight(),
      winW: any = $(window).innerWidth(),
      menuHeight = numberOfOptions * 27;
      // menuWidth = 130;

    let menuWidth = this.$el && this.$el.outerWidth() ? this.$el.outerWidth() : 130;

    let left = e.clientX;
    let top = e.clientY;
    let bottomMenu = top + menuHeight;
    let rightMenu = left + menuWidth;
    //max height and width of context menu
    if (bottomMenu > winH) {
      if ((top - menuHeight) < 0) {
        if ((bottomMenu - winH) < (menuHeight - top)) {
          top = winH - menuHeight;
        } else {
          top = 0;
        }
      } else {
        top = top - menuHeight;
      }
    }
    if (rightMenu > winW) {
      if ((left - menuWidth) < 0) {
        if ((rightMenu - winW) < (menuWidth - left)) {
          left = winW - menuWidth;
        } else {
          left = 0;
        }
      } else {
        left = left - menuWidth;
      }
    }

    let cssObj: any = {
      'position': 'fixed',
      'display': 'inline-block',
      'height': '',
      'width': ''
    };

    cssObj.left = left + 'px';
    cssObj.top = top + 'px';

    return cssObj;
  }

}
